import React from "react";
import {Link} from "react-router-dom";
import pageList from './pageList';
import Request, {CODES} from '../../utils/Request';
import {RegisterStock} from '../../utils/svgs';
import {translateStatus} from '../../utils/translations'

// import GeneralAnimations from '../utils/generalAnimations';
// import {TweenMax, Power2} from "gsap/TweenMax";


class pageListOrdersRegistered extends pageList {
	
	constructor(props){
		super(props)

		this.responseField = 'orders';
		this.apiName = 'orders-registered';
		this.listSlug = 'orders-registered';
		this.itemLinkSlug = 'pedidos-registrados'
		this.singleItem = 'pedido'; //Name of a single list item
		this.listTitle = 'Pedidos registrados';
		
		// this.itemLinkSlug = 'pedidos';

		this.hasRowOptions = false;

	}
	
	componentDidMount(){
		this.requestPages();
	}

	getTable(pages){
		let table = {};
		table.headers = [
			{
				slug: 'order_sold',
				name: 'Pedido',
				class: 'item-big',
				canSearch: true,
			},
			{
				slug: 'date_sold',
				name: 'Fecha pedido',
				class: 'item-big',
				canSort: true,
				sortType: 'string'
			},
			{
				slug: 'n_prod',
				name: 'Número de productos',
				class: 'item-medium',
				canSort: true,
			},
		];
		table.rows = [];
		for(let i = 0; i < pages.length; i++){
			table.rows.push(this.createRow(pages[i]));
		}
		return table;
	}

	createRow(page){
		page.id = page.date_sold+'/'+page.order_sold;
		return {
			item : page,
			id: page.id,
			order_sold : page.order_sold,
			date_sold : page.date_sold,
			n_prod : page.n_prod,
		};
	}

	
	renderAddNew(){}
	
}





export default pageListOrdersRegistered;




